module.exports = __webpack_public_path__ + "img/ZJ5275.cc92de46.png";